export default "__VITE_ASSET__BpUTLXVW__"